import { connect } from 'react-redux'
import MarketView from '../components/MarketView'
import {changeStep} from '../modules/step'

const mapDispatchToProps = {
  changeStep: changeStep
};

const mapStateToProps = (state) => ({
  step: state.step,
  selectedCategory: state.categories.selectedCategory,
  appGuid: state.app.app_guid,
  loadingContent: state.loadingContent,
  language: state.i18n.locale,
  paymentsCount: state.cart.payments && state.cart.payments.length
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketView)


// WEBPACK FOOTER //
// ./src/layouts/Content/containers/MarketContainer.js